import { TopDownItemId } from './config';
import type { FocusPlacement } from './positions';

/**
 * Visual overrides for an item when it is the primary focused item.
 * Only properties that differ from the base/scatter configuration
 * need to be specified.
 */
export interface ItemFocusedPoseConfig {
    focusPlacement?: FocusPlacement;
}

/**
 * Get configuration map for each item's focused pose.
 * These are used as the first-level overrides in `getTargetPose`
 * when the item is currently focused.
 * @param mobile - Whether the device is mobile. Shoes and Bowtie focus placement only applies on mobile.
 */
export function getFocusConfig(mobile: boolean): Map<TopDownItemId, ItemFocusedPoseConfig> {
    const config = new Map<TopDownItemId, ItemFocusedPoseConfig>([
        [TopDownItemId.Schedule, {
            focusPlacement: {
                top: '3%', // Center vertically when zoomed in
                left: '-10%',
                width: '120%', // Zoom in ~20% when focused
                rotate: '0deg', // Reduce tilt for readability
            }
        }],
    ]);

    // Shoes and Bowtie focus placement only applies on mobile
    if (mobile) {
        config.set(TopDownItemId.Shoes, {
            focusPlacement: {
                top: '-4%',
                left: '-33%',
                // width: '120%',
                rotate: '20deg', // Inverted from base rotation
            }
        });
        config.set(TopDownItemId.Bowtie, {
            focusPlacement: {
                top: '5%',
                left: '82%',
                width: '25%', // Zoom in ~10% when focused
                rotate: '-13deg', // Inverted from base rotation
                z: 100,
            }
        });
    }

    return config;
}

